import { Project } from '../types';

export const calculateTotalRidership = (matrices: {
  ridership: number[][];
}): number => {
  return matrices?.ridership?.reduce(
    (sum, row) => sum + row.reduce((rowSum, cell) => rowSum + cell, 0),
    0
  ) / 2 || 0;
};

export function formatNumber(value: number): string {
  if (value === 0) return '0';
  
  const billion = 1000000000;
  const million = 1000000;
  const thinSpace = '\u2009';

  if (Math.abs(value) >= billion) {
    const valInBillions = Math.abs(value) / billion;
    const decimals = valInBillions < 10 ? 2 : valInBillions < 100 ? 1 : 0;
    const formattedValue = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(valInBillions);
    return `${value < 0 ? '-' : ''}${formattedValue}${thinSpace}billion`;
  } else if (Math.abs(value) >= million) {
    const valInMillions = Math.abs(value) / million;
    const decimals = valInMillions < 10 ? 2 : valInMillions < 100 ? 1 : 0;
    const formattedValue = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(valInMillions);
    return `${value < 0 ? '-' : ''}${formattedValue} million`;
  } else {
    // For raw passenger counts, use whole numbers only
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }).format(Math.round(value));
  }
} 